<template>
    <div>
      
        <form class="mt-4">
            <div class="flex gap-6">
                <div class="flex-1 ">
                    <label for="fullname" class="label">Full Name</label>
                    <input type="text" class="input" v-model="kyc.fullName" placeholder="-- Enter Full Name --" />
                </div>
                <div class="flex-1 ">
                     <label for="mname" class="label">Country</label>
                    <el-select v-model="selectedCountry" value-key="isoCode" placeholder="-- Select Country --">
                        <el-option v-for="country in countries" :key="country.isoCode" :label="country.name"
                            :value="country">
                        </el-option>
                    </el-select>
                </div>
                <div class="flex-1 ">
                     <label for="email" class="label">Email Address</label>
                    <input type="email"  class="input" v-model="kyc.email" />
                </div>
            </div>
            <div class="flex gap-6 mt-4 mb-4">
                <div class="flex-1 ">
                    <label for="number" class="label">Phone Number</label>
                     <vue-tel-input :preferredCountries="['Nigeria']" v-model="kyc.mobile_no"></vue-tel-input> 
                </div>
                <div class="flex-1 ">
                    <label for="equity" class="label">Equity (%)</label>
                    <input type="text" class="input" v-model="kyc.equity" placeholder="-- Enter Equity --" />                  
                </div>
                <div class="flex-1 ">
                    
                </div>
            </div>
                    
            <div class="next-submit flex justify-end mt-4">
                <button @click="goToIdentity"
                    :class="['py-2 px-4 text-[16px] font-semibold text-[#10233E] transition-all duration-300', buttonClass]">
                    Next
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import { Country } from "country-state-city";

export default {

    props: {
        selected: String,
    },


    data() {
        return {
             countries: [],
            selectedCountry: null,
            fileType: '',
            kyc: {
                fullName: '',
                email: "",
                equity: "",
                country: "",
                mobile_no: "",
            },
        };
    },

    watch: {
      
        selectedCountry(newVal) {
            if (!newVal) {
                return
            }

            this.kyc.country = newVal.name
        },

    },
    
    mounted() {
          this.countries = Country.getAllCountries();
      
    },

    computed: {
        buttonClass() {
            return this.isFormValid
                ? 'opacity-100 cursor-pointer hover:scale-105'
                : 'opacity-50 cursor-not-allowed';
        },

        isFormValid() {
            return (
                this.kyc.fullName.trim() &&
                this.kyc.email.trim() &&
                this.kyc.country.trim() &&
                this.kyc.mobile_no.trim() &&
                this.selected === 'Owner' &&
                this.kyc.equity.trim()
            );
        }
    },

    methods: {
        goToIdentity(e) {
            e.preventDefault();
            if (this.isFormValid) {
                this.$emit('openIdentity', {
                    ...this.kyc,
                    selected: this.selected
                });
            } else {
                this.generateToast("Form is invalid, cannot proceed.", "error");
                return;
            }
            this.kyc = {
                fullName: '',
                email: "",
                equity: "",
                country: "",
                mobile_no: "",
            }
        },

    }

}
</script>

<style scoped>
label {
    font-weight: 700;
    font-size: 14px;
    color: #383F51;
}

input {
    background-color: #FBFCFE;
    border: 1px solid #DAE8F6;
    border-radius: 2px;
    padding: 2% 0 2% 2%;
    width: 100%;
}

.next-submit>button {
    background-color: #FCC210;
    border-radius: 2px;
    /* opacity: 0.5;
    cursor: not-allowed; */
}

form>:nth-child(1)>:nth-child(3)>button,
form>:nth-child(2)>:nth-child(3)>button,
form>:nth-child(2)>:nth-child(2)>button,
form>:nth-child(2)>:nth-child(1)>button,
form>:nth-child(3)>:nth-child(1)>button,
form>:nth-child(3)>:nth-child(3)>button {
    background-color: #FBFCFE;
    border: 1px solid #DAE8F6;
    border-radius: 2px;
    padding: 2% 2% 2% 2%;
    width: 100%;
}
</style>
